import { Container, Sprite } from 'pixi.js';
import { IStateCurrency } from '../../State/reducers/currency';
import { IStatePlayer } from '../../State/reducers/player';
import CurrencyDisplay from './CurrencyDisplay';
import HeartDisplay from './HeartDisplay';
import Core, { GameOrientation } from '../../Core/Core';

interface ICurrencyDisplays {
    [keys: string]: CurrencyDisplay | HeartDisplay;
}

/**
 * UI group at the top of the map screen, shows what player has for lives, coins and stars
 *
 * @params addCurrency - function to handle player adding currency with the plus buttons
 */
export default class TopMapUi extends Container {
    public timeLeft: string;
    public hearts: HeartDisplay;
    public coins: CurrencyDisplay;
    public stars: CurrencyDisplay;
    private displays: ICurrencyDisplays;

    constructor() {
        super();

        const bg = new Sprite(PIXI.utils.TextureCache['mapui/tophud-bg']);

        this.displays = {};
        const hearts = new HeartDisplay(5);
        hearts.x = bg.width * 0.04 + hearts.width * 0.5;
        hearts.y = bg.height * 0.5;
        const stars = new CurrencyDisplay('star');
        stars.x = bg.width * 0.5;
        stars.y = bg.height * 0.5;
        const coins = new CurrencyDisplay('coin');
        coins.x = bg.width * 0.98 - coins.width * 0.5;
        coins.y = bg.height * 0.5;

        //@ts-ignore
        this.addChild(bg, hearts, stars, coins);

        if (Core.orientation === GameOrientation.LANDSCAPE) {
            bg.alpha = 0;
        }

        this.hearts = hearts;
        this.displays.heart = hearts;
        this.stars = stars;
        this.displays.star = stars;
        this.coins = coins;
        this.displays.coin = coins;
    }

    /**
     * public function called to update all stats
     * @param player - player data passed in
     * @param currencies - currency data passed in
     *
     * actually I will probably change this to pass in the data as more simple types
     * ( ie hearts: number, totalStars: number, coins: number )
     * but can be used as is for now
     */
    public showAllStats(player: IStatePlayer, currencies: IStateCurrency) {
        this.displays.heart.showCurrencyValue(currencies.heart);
        this.displays.star.showCurrencyValue(player.totalStars);
        this.displays.coin.showCurrencyValue(currencies.coin);
    }

    // updates just coins
    public updateCurrency(currencyId: string, currencyVal: number) {
        this.displays[currencyId].showCurrencyValue(currencyVal);
    }

    // shows current time left until next heart
    public updateTimer(timeLeft: string) {
        this.timeLeft = timeLeft;
        (this.displays.heart as HeartDisplay).showHeartTime(timeLeft);
    }
}
